export default function StackIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={0.8}
        d="M22.667 12a.333.333 0 00-.21-.31l-6.31-2.523 6.31-2.524a.334.334 0 000-.62l-10-4a.334.334 0 00-.247 0l-10 4a.333.333 0 000 .62l6.31 2.524-6.31 2.523a.333.333 0 000 .62l6.31 2.523-6.31 2.524a.333.333 0 000 .62l10 4c.08.03.168.03.247 0l10-4a.334.334 0 000-.62l-6.31-2.524 6.31-2.523a.334.334 0 00.21-.31zM3.23 6.333l9.103-3.64 9.102 3.64-9.102 3.641-9.103-3.64zm18.205 11.334l-9.102 3.64-9.103-3.64 6.186-2.475 2.793 1.118a.34.34 0 00.247 0l2.793-1.117 6.186 2.474zm-9.102-2.026L3.23 12l6.186-2.474 2.793 1.117a.33.33 0 00.247 0l2.793-1.117L21.436 12l-9.102 3.64z"
      />
    </svg>
  );
}
